<ng-container *transloco="let t">
  @if (getBlogEntries200Response$ | async; as getBlogEntries200Response) {
    <button
      (click)="openCreateModal()"
      class="btn btn-circle btn-primary float-left mt-4 ml-4"
    >
      <svg
        class="inline-block h-6 w-6 stroke-current"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6v12m6-6H6"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        ></path>
      </svg>
    </button>
    <div
      [ngClass]="{
        'grid-cols-1': layoutColumns === 1,
        'grid-cols-1 lg:grid-cols-2': layoutColumns === 2,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3': layoutColumns === 3,
      }"
      class="grid gap-4 p-4"
    >
      @for (item of getBlogEntries200Response.data; track item) {
        <core-information-card
          (editInformationCardEvent)="openEditModal(item)"
          [title]="item.title | translationsDto"
          (removeInformationCardEvent)="deleteBlogPost(item)"
          (readMoreInformationCardEvent)="openEditModal(item)"
          buttonTitle="{{ t('news-blog-button-title') }}"
          [author]="item.author?.fullName"
          [content]="item.content | translationsDto"
          [image]="
            !!item.teaserImageUuid
              ? item.teaserImageUuid
              : 'https://img.daisyui.com/images/stock/photo-1606107557195-0e29a4b5b4aa.jpg'
          "
          [publishedDate]="item.publishedAt"
        >
        </core-information-card>
      }
    </div>
    <!-- Pagination -->
    <div class="flex items-center justify-center p-4">
      @if (
        getBlogEntriesRequestParams$ | async;
        as getBlogEntriesRequestParams
      ) {
        <div class="flex space-x-1">
          <button
            (click)="changePage(getBlogEntriesRequestParams.page! - 1)"
            [disabled]="getBlogEntriesRequestParams.page! <= 1"
            class="btn btn-outline"
          >
            {{ t('news-blog-previous-button') }}
          </button>
          <div class="join">
            @for (
              page of getPages(getBlogEntries200Response.meta.totalPages);
              track page
            ) {
              <button
                (click)="changePage(page)"
                [class.btn-active]="page === getBlogEntriesRequestParams.page"
                class="btn btn-outline join-item"
              >
                {{ page }}
              </button>
            }
          </div>
          <button
            (click)="changePage(getBlogEntriesRequestParams.page! + 1)"
            [disabled]="
              getBlogEntriesRequestParams.page! >=
              getBlogEntries200Response.meta.totalPages
            "
            class="btn btn-outline"
          >
            {{ t('news-blog-next-button') }}
          </button>
        </div>
      }
    </div>
  }
</ng-container>
